import { type ActiveOverride, type RotationBase } from '../../../common/types';
import type { ScheduleEntity } from '../../../services/endpoints/list/types';

export enum OverrideVariant {
	Add = 1,
	Edit,
	Customize,
}

export enum DiscardVariant {
	Discard = 1,
	Close,
}

export enum CreateVariant {
	Create = 1,
	Clone,
}

export type PageStore = {
	/** @description responder within the override has to have OG ID, because it would be used as input in autocomplete */
	activeOverride?: ActiveOverride<false, false>;
	activeSchedule?: ScheduleEntity;
	activeRotation?: RotationBase;
	createVariant?: CreateVariant;
	overrideVariant?: OverrideVariant;
	discardVariant?: DiscardVariant;
	sources: Array<string | null | undefined | Array<string | null | undefined>>;
	isAddOverrideOpen: boolean;
	isCreateScheduleOpen: boolean;
	isDeleteScheduleOpen: boolean;
	isDeleteRotationOpen: boolean;
	isEditModeOpen: boolean;
	isRevertOverrideOpen: boolean;
	isTakeOnCallOpen: boolean;
	isDiscardChangesOpen: boolean;
};
